import { render, staticRenderFns } from "./upstreamCustomerEdit.vue?vue&type=template&id=0f931cfa&scoped=true"
import script from "./upstreamCustomerEdit.vue?vue&type=script&lang=js"
export * from "./upstreamCustomerEdit.vue?vue&type=script&lang=js"
import style0 from "./upstreamCustomerEdit.vue?vue&type=style&index=0&id=0f931cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f931cfa",
  null
  
)

export default component.exports